import React, { useState, useEffect } from "react";
import { useLanguage } from "@/contexts/LanguageContext";

export function CookieBanner() {
  const [visible, setVisible] = useState(false);
  const { t } = useLanguage();

  useEffect(() => {
    const consent = localStorage.getItem("cookie_consent");
    if (!consent) {
      setVisible(true);
    }
  }, []);

  const accept = () => {
    localStorage.setItem("cookie_consent", "accepted");
    setVisible(false);
  };

  const decline = () => {
    localStorage.setItem("cookie_consent", "declined");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div style={{
      position: "fixed",
      bottom: 0,
      left: 0,
      right: 0,
      zIndex: 9999,
      background: "var(--charcoal)",
      color: "var(--stone-gray)",
      padding: "20px 32px",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      gap: "24px",
      flexWrap: "wrap",
      boxShadow: "0 -4px 24px rgba(0,0,0,0.2)",
      fontFamily: "'Lato', sans-serif",
      fontSize: "14px",
      lineHeight: "1.6",
    }}>
      <p style={{ margin: 0, flex: 1, minWidth: "240px" }}>
        {t("cookie.text")}{" "}
        <a
          href="/privacy-policy"
          style={{ color: "var(--gold-accent)", textDecoration: "underline" }}
        >
          {t("cookie.learnMore")}
        </a>
      </p>
      <div style={{ display: "flex", gap: "12px", flexShrink: 0 }}>
        <button
          onClick={decline}
          style={{
            background: "transparent",
            border: "1px solid var(--stone-dark)",
            color: "var(--stone-gray)",
            padding: "10px 20px",
            cursor: "pointer",
            fontFamily: "'Lato', sans-serif",
            fontSize: "13px",
            letterSpacing: "0.05em",
          }}
        >
          {t("cookie.decline")}
        </button>
        <button
          onClick={accept}
          style={{
            background: "var(--gold-accent)",
            border: "none",
            color: "var(--charcoal)",
            padding: "10px 24px",
            cursor: "pointer",
            fontFamily: "'Lato', sans-serif",
            fontSize: "13px",
            fontWeight: "700",
            letterSpacing: "0.05em",
          }}
        >
          {t("cookie.accept")}
        </button>
      </div>
    </div>
  );
}
